import type {ExamModule} from '@cp/model';
import {useCallback} from 'react';
import getExamModuleDoc from '../../api/examModules/getExamModuleDoc';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useGetExamModule(id: string, options?: {skip?: boolean}) {
  const load = useCallback((): Promise<ExamModule | undefined> => getExamModuleDoc(id), [id]);

  const {data, loading, error, refetch} = useFunctionRun(load, {
    skip: !id || options?.skip,
  });

  return {
    examModule: data,
    loading,
    error,
    getExamModule: refetch,
  };
}
